import route from './route';
import portal from './portal';
export default {
  route,
  portal,
};